import React, { useMemo } from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client';

import { type PrimaryProductKey, PrimaryProductKeys } from '../../../../common/constants/products';
import { isUserOAuthed } from '../../../../controllers/oauth';
import { useThirdPartyConfigs } from '../../../../controllers/store/bootstrap';

import { AllAppsConfluenceFirst } from './search-all-apps-icon/AllAppsConfluenceFirst';
import { AllAppsJiraFirst } from './search-all-apps-icon/AllAppsJiraFirst';
import { AllAppsJiraFirstWithGithub } from './search-all-apps-icon/AllAppsJiraFirstWithGithub';

export const useJiraAllAppsIcon = (product?: PrimaryProductKey) => {
	const [thirdPartyConfigs] = useThirdPartyConfigs();

	return useMemo(() => {
		if (product !== PrimaryProductKeys.Jira) {
			return <AllAppsConfluenceFirst />;
		}

		const isGitHubConnected = !isUserOAuthed('github', thirdPartyConfigs ?? {}).userNeedsOAuth;
		const showGitHubIcon =
			isGitHubConnected &&
			FeatureGates.getExperimentValue<string>(
				'github_icon_in_jira_all_apps_experiment',
				'isEnabled',
				'false',
			) === 'true';

		return showGitHubIcon ? <AllAppsJiraFirstWithGithub /> : <AllAppsJiraFirst />;
	}, [product, thirdPartyConfigs]);
};
